import { SPToast, SPTopbar } from '@group-link-one/gl-ui/sonarprint';
import { AnimatePresence, motion } from 'motion/react';
import type { IPageLayoutRight } from '../types/PageLayoutRight.types';
import { SnackbarContainer, TopContentContainer } from './PageLayoutStyle';
import { usePageLayoutContent } from './usePageLayoutContent';

export function PageLayoutContent({
  children,
  profileMenuOptions,
  topbarOptions,
  sidebarOptions,
  id,
}: IPageLayoutRight) {
  const { content, snackbar, setSnackbarState, pageTitle } = usePageLayoutContent();

  return (
    <>
      <AnimatePresence mode='wait' initial={false}>
        {!!content && (
          <TopContentContainer
            key={`${id}-top-content`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            {content}
          </TopContentContainer>
        )}

        {!content && (
          <motion.div
            key={`${id}-topbar`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            // Sit above full-screen map overlays (e.g. the H3 page portals a `z-index: 1` map to
            // `document.body`), so the topbar/page title stays visible instead of being painted over.
            style={{ position: 'relative', zIndex: 2 }}
          >
            <SPTopbar
              rightItems={topbarOptions.rightItems || []}
              addonItems={topbarOptions.addonItems || []}
              profileMenuOptions={profileMenuOptions}
              pageTitle={pageTitle ?? undefined}
              sidebarItems={[
                ...(sidebarOptions?.topItems || []),
                ...(sidebarOptions?.bottomItems || []),
              ]}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode='wait' initial={false}>
        {!!snackbar && (
          <SnackbarContainer
            key={`${id}-snackbar`}
            initial={{ opacity: 0, y: -20, height: 0 }}
            animate={{ opacity: 1, y: 0, height: 'auto' }}
            exit={{ opacity: 0, y: -20, height: 0 }}
          >
            <SPToast
              {...snackbar}
              mode='snackbar'
              title={snackbar.title || ''}
              message={snackbar.message || ''}
              onClose={() => setSnackbarState(null)}
            />
          </SnackbarContainer>
        )}
      </AnimatePresence>

      {children}
    </>
  );
}
